import { useTranslation } from 'react-i18next'
import { Chip } from '@structural-climbing/ui'
import type { IdeaKind, IdeaStatus } from './useIdeas'

// Each status reads at a glance: green when it is in, amber while it is being
// weighed, the gym's colour once chosen, solid ink once built, quiet grey when
// it is not this time.
const LOOK: Record<IdeaStatus, string> = {
  new: 'bg-success/15 text-success-700',
  review: 'bg-warning/20 text-warning-700',
  top: 'bg-[var(--gym-primary)] text-white',
  built: 'bg-foreground text-background',
  declined: 'bg-foreground/[0.07] text-foreground/60',
  read: 'bg-primary/15 text-primary-700',
}

export function statusLabelKey(kind: IdeaKind, status: IdeaStatus): string {
  return kind === 'feedback' ? `ideas.statusFeedback.${status}` : `ideas.statusIdea.${status}`
}

export function IdeaStatusChip({ kind, status }: { kind: IdeaKind; status: IdeaStatus }) {
  const { t } = useTranslation()
  return (
    <Chip
      size="sm"
      radius="full"
      classNames={{ base: `shrink-0 border-0 ${LOOK[status]}`, content: 'font-bold' }}
    >
      {t(statusLabelKey(kind, status))}
    </Chip>
  )
}
